import script from "./MyRolePanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyRolePanel.vue?vue&type=script&setup=true&lang=ts"

import "./MyRolePanel.vue?vue&type=style&index=0&id=cb3429ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb3429ae"]])

export default __exports__